var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3796",
    "data-name": "Group 3796",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 9.963,
    viewBox: "0 0 16 9.963",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    width: 16,
    height: 9.963,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    d: "M0,1.27c.035-.113.062-.229.105-.339A1.466,1.466,0,0,1,1.512,0Q5.486,0,9.46,0a1.46,1.46,0,0,1,1.516,1.515c0,.364,0,.727,0,1.091,0,.05,0,.1.009.171.092-.035.169-.063.244-.093l4.008-1.6c.384-.153.577-.082.763.277V8.6c-.186.359-.38.43-.763.277L11.156,7.248c-.051-.02-.1-.038-.18-.066V7.6c0,.275,0,.551,0,.826A1.468,1.468,0,0,1,9.444,9.961c-1.14,0-2.28,0-3.419,0q-2.233,0-4.466,0a1.484,1.484,0,0,1-1.48-1C.049,8.872.026,8.782,0,8.694V1.27M5.493.937H1.6c-.473,0-.667.191-.667.658q0,3.391,0,6.781c0,.456.2.65.659.65H9.39c.454,0,.649-.193.649-.642q0-3.4,0-6.8c0-.46-.193-.65-.657-.65H5.493m9.559,6.857V2.176c-.031.01-.05.016-.069.023q-1.955.78-3.91,1.557c-.1.04-.1.1-.1.181,0,.691,0,1.383,0,2.074a.192.192,0,0,0,.143.216c.692.27,1.382.547,2.072.822l1.864.745",
    transform: "translate(0 0)",
    fill: "#1976d2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video.1251070fc87170022357bbf2a0e3576b.svg";